import React from "react";

const ShoppingBag = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-shopping-bag"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-shopping-bag"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M21,6H18A6,6,0,0,0,6,6H3A3,3,0,0,0,0,9V19a5.006,5.006,0,0,0,5,5H16.686A6,6,0,1,1,24,14.537V9A3,3,0,0,0,21,6ZM8,6a4,4,0,0,1,8,0Z" />
      <path d="M23,18H21V16a1,1,0,0,0-2,0v2H17a1,1,0,0,0,0,2h2v2a1,1,0,0,0,2,0V20h2a1,1,0,0,0,0-2Z" />
    </svg>
  );
};

export default ShoppingBag;
